import React from "react";
import dayjs from "dayjs";
import { CardInIcon, CardOutIcon, IbanInIcon, TaxOutIcon } from "Shared/icons";

export const dataSource = (dataArr = []) => {
	function selectOerationIcon(operation) {
		switch (operation) {
			case "in":
				return <CardInIcon />;
			case "out_paypal":
			case "out_admin":
				return <CardOutIcon />;
			case "out_iban":
				return <IbanInIcon />;
			case "out_tax":
				return <TaxOutIcon />;

			default:
				break;
		}
	}

	return dataArr.map((data) => {
		let symbol = "";
		if (data.operation.includes("out")) {
			symbol = "-";
		} else symbol = "+";
		return {
			operation: selectOerationIcon(data.operation),
			date: dayjs(data.date).format("DD.MM.YY HH:mm"),
			amount: `${symbol} ${data.amount}`,
			comment: operation_context_map[data.operation_context] ?? data.comment,
			key: data.id,
		};
	});
};

const operation_context_map = {
	open_challenge: "Open Challenge Entry fee",
	open_challenge_award: "Replenishment (Open challenge prize)",
	open_challenge_cancel: "Open Challenge cancel",
	competition_cancel: "Competition cancel",
	competition: "Competition registration",
	rematch: "Competition entry fee",
	rematch_cancel: "Competition entry fee cancel",
};
